export function createVisiblePoller({
  poll,
  intervalMs,
  isVisible,
  setTimer,
  clearTimer,
  subscribeVisibility,
  refreshOnVisible = true,
}) {
  let stopped = true;
  let running = false;
  let timer = null;
  let unsubscribe = () => undefined;

  const clearScheduled = () => {
    if (timer === null) return;
    clearTimer(timer);
    timer = null;
  };

  const schedule = () => {
    clearScheduled();
    if (stopped || !isVisible()) return;
    timer = setTimer(() => {
      timer = null;
      void run();
    }, intervalMs);
  };

  const run = async () => {
    if (stopped || running || !isVisible()) return;
    running = true;
    try {
      await poll();
    } catch {
      // The owning hook renders request failures. Polling must remain alive.
    } finally {
      running = false;
      schedule();
    }
  };

  const visibilityChanged = () => {
    clearScheduled();
    if (!isVisible()) return;
    if (refreshOnVisible) void run();
    else schedule();
  };

  return {
    start() {
      if (!stopped) return;
      stopped = false;
      unsubscribe = subscribeVisibility(visibilityChanged);
      schedule();
    },
    stop() {
      if (stopped) return;
      stopped = true;
      clearScheduled();
      unsubscribe();
      unsubscribe = () => undefined;
    },
  };
}
